import React, { useEffect, useState } from 'react'
import { Modal, Button } from '../ui'

// Subí este número cuando quieras volver a mostrar el aviso a todos.
const WHATS_NEW_VERSION = '2026-06'
const STORAGE_KEY = 'sr_whatsnew_seen'

const Item = ({ icon, color, title, children }) => (
  <div className="flex gap-3">
    <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl ${color}`}>
      <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={icon} />
      </svg>
    </span>
    <div>
      <p className="text-sm font-semibold text-ink">{title}</p>
      <p className="text-sm text-ink-soft">{children}</p>
    </div>
  </div>
)

/**
 * Aviso de novedades mostrado una sola vez por usuario/navegador.
 */
export default function WhatsNewModal() {
  return null
}
